import apiClient from '@/services/axios'

export async function put(payload) {
  var response = await apiClient.put('Accounts/trial-period', payload)
  if (response) {
    return response.data
  }

  throw new Error('Unable to update trial config.')
}